export const getClaimListingLink = (supplier) => {
    const baseLink = "https://docs.google.com/forms/d/e/1FAIpQLSfj4_2X4wRKNWAeJLIBLiKuOAouXVey0X3S8s_yQ-me10vcgQ/viewform";
    const nameInputHTMLID = "entry.381506947";
    const idInputHTMLID = "entry.280287387";
    if (!supplier?.id || !supplier?.name) {
        return baseLink;
    }
    return `${baseLink}?${idInputHTMLID}=${supplier.id}&${nameInputHTMLID}=${supplier.name}`;
};
